export default __webpack_public_path__ + "static/sso-auth-bd6852e835acda76a6e485102cf6e5f6.png";